import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function DifferentiatingStatement() {
  return <SectionWrapper data-id="element-40">
      <div className="max-w-[680px] mx-auto text-center space-y-6" data-id="element-41">
        <p className="text-3xl md:text-4xl lg:text-[2.75rem] font-serif text-text leading-tight" data-id="element-42">
          Las mujeres más responsables son las que más absorben lo que no es
          suyo.
        </p>
        <p className="text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-43">
          No porque sean débiles. Sino porque nadie les enseñó a regular.
        </p>
      </div>
    </SectionWrapper>;
}